// extracted by mini-css-extract-plugin
export default {"base":"Pill_base__-xZRb","left-icon":"Pill_left-icon__7AQwX"};